import { render, staticRenderFns } from "./PracticePeriodModal.vue?vue&type=template&id=5792a0bc"
import script from "./PracticePeriodModal.vue?vue&type=script&lang=ts"
export * from "./PracticePeriodModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports